import { render, staticRenderFns } from "./rostros.vue?vue&type=template&id=66991a50&scoped=true"
var script = {}
import style0 from "./rostros.vue?vue&type=style&index=0&id=66991a50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66991a50",
  null
  
)

export default component.exports